import {DebuggingComponent} from '@fantasmagames/slot/src/common/debugging/DebuggingComponent';

export class WinPresentationDebuggingComponent extends DebuggingComponent {
	public init(): void {
		super.init();

		this.addWindowFunction('showWinCounter', this.showWin.bind(this));
	}

	protected showWin(winAmount: number, isExcellent: boolean = false): void {
		(this.view as any).playWinNumberCounter(winAmount, isExcellent);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/winpresentation/debuggingComponent/WinPresentationDebuggingComponent.ts